module.exports = __webpack_public_path__ + "img/icon-illustration-coupon-item-normal.43a21148.svg";